import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

// Cached map of dancerName -> studio they most recently transferred to (active transfers only,
// transfer date already reached). Same source Eternal Cup Ranking uses for its studio column.
let _transfersPromise = null;
let _transfersTime = 0;
const TTL = 5 * 60 * 1000;

export function getLatestTransferStudios() {
  if (_transfersPromise && Date.now() - _transfersTime < TTL) return _transfersPromise;
  _transfersTime = Date.now();
  _transfersPromise = getDocs(query(collection(db, 'studioTransfers'), where('status', '==', 'active')))
    .then(snap => {
      const now = new Date();
      const latest = new Map(); // dancerName -> { studio, date }
      snap.forEach(d => {
        const t = d.data();
        if (!t.dancerName || !t.toStudio) return;
        const date = t.transferDate?.toDate ? t.transferDate.toDate() : new Date(t.transferDate);
        if (isNaN(date) || date > now) return;
        const prev = latest.get(t.dancerName);
        if (!prev || date > prev.date) latest.set(t.dancerName, { studio: t.toStudio, date });
      });
      return new Map([...latest].map(([name, v]) => [name, v.studio]));
    })
    .catch(() => {
      _transfersPromise = null;
      return new Map();
    });
  return _transfersPromise;
}

/**
 * Studio assigned on the dancer's profile, for dancers whose competition results carry none.
 * Discipline-specific assignment wins, then primary studio, then the generic studio fields.
 */
export async function getProfileStudio(dancerName, discipline = null) {
  try {
    const [profileSnap, dancerSnap] = await Promise.all([
      getDoc(doc(db, 'dancerProfiles', dancerName)),
      getDoc(doc(db, 'dancers', dancerName)),
    ]);
    if (profileSnap.exists()) {
      const p = profileSnap.data();
      const fromDiscipline = discipline && p.disciplineStudios && p.disciplineStudios[discipline];
      const anyDiscipline = p.disciplineStudios && Object.values(p.disciplineStudios).find(Boolean);
      const studio = fromDiscipline || p.primaryStudio || p.studio || anyDiscipline;
      if (studio) return studio;
    }
    if (dancerSnap.exists()) {
      const s = dancerSnap.data().studio;
      if (s) return s;
    }
  } catch (e) {
    // fall through
  }
  return null;
}
